import { quotesBlotterApiConnector, ServerSideBlotterSearchRequest } from 'apiConnector/blotters/quotesBlotter';
import type { StringFileResponse } from 'models/FileResponse';
import { useCallback } from 'react';
import { EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
import { downloadCsv } from 'utils/documents/downloadDocument';
import { httpClient } from 'utils/http/httpClient';

import { logAnalytics } from '../../../../shared/middlewares/analytics/logger';

const api = quotesBlotterApiConnector(httpClient);

export function useBlotterItemsFetch(request: ServerSideBlotterSearchRequest | undefined) {
  return useCallback(() => {
    if (request === undefined) {
      return EMPTY;
    }
    return api.fetchCSV(request).pipe(
      map((response: StringFileResponse) => {
        logAnalytics.trackEvent('Blotter My Quotes', 'Download CSV');
        downloadCsv(response.data, response.filename);
      }),
    );
  }, [request]);
}
